module.exports = __webpack_public_path__ + "img/first-page.a2b0a3b2.svg";